import { useState, useEffect } from 'react';

/**
 * Hook personalizado para detectar el estado de conexión a Internet
 * @returns {boolean} true si hay conexión, false si está offline
 */
export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = () => {
      console.log('🌐 Conexión restablecida');
      setIsOnline(true);
    };

    const handleOffline = () => {
      console.log('📴 Conexión perdida - Modo offline activado');
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};
